import React, { useContext, lazy, Suspense } from "react";
import { theme } from "./Theme"
import clsx from "clsx";
import { makeStyles, ThemeProvider } from "@material-ui/core/styles";
import { Route, 
  Switch, 
  withRouter, 
  useHistory 
} from "react-router-dom";

import { 
  AppBar, 
  Container, 
  CssBaseline,
  IconButton, 
  Menu, 
  MenuItem, 
  Toolbar, 
  Tooltip,
  Typography,
} from "@material-ui/core";

import { LoaderSuspense } from '../layout/feedback/LoaderSuspense'
import { MdMenu, MdAccountCircle } from "react-icons/md"
import { Role } from "types/roles";
import { Util } from "helpers/Util";
import AuthContext from "context/autentication/authContext";
import IsMobileContext from "context/isMobile/isMobileContext";
import ListaSoporte from '../layout/Sidebar/ListaSoporte'
import LogState from 'context/log/logState';
import MenuNotificaciones from "components/CampanaAlertas/CampanaNotificaciones";
import RutaPrivada from "components/rutas/RutaPrivada";
import Sidebar from "./Sidebar/Sidebar";

const AdminDashboardPage = lazy(() => import("pages/AdminDashboardPage"));
const AlertasProvider = lazy(() => import("components/Alertas/AlertasProvider"));

const ApplicationScreen = lazy(() => import("components/Superadmin/Application/ApplicationItem/ApplicationScreen"))
const ApplicationsScreen = lazy(() => import("components/Superadmin/Application/ApplicationsScreen"))
const CentroDeAyudaScreen = lazy(() => import("components/CentroDeAyuda/CentroDeAyudaScreen"));
const Cliente = lazy(() => import("components/Cliente/Cliente2"));
const Contacto = lazy(() => import("components/CentroDeAyuda/Contactar"))
const DashboardScreen = lazy(() => import("components/DashboardWidgets/DashboardScreen"));
const DeviceProfileScreen = lazy(() => import('components/Superadmin/DeviceProfile/DeviceProfileItem/DeviceProfileScreen'))
const DeviceProfilesScreen = lazy(() => import('components/Superadmin/DeviceProfile/DeviceProfilesScreen'))
const EditarDispositivo = lazy(() => import("components/Dispositivo/EditarDispositivo/EditarDispositivo"));
const EditarVariableScreen = lazy(() => import("components/Variable/EditarVariable/EditarVariableScreen"));
const EstadisticasScreen = lazy(() => import("components/Superadmin/Estadisticas/EstadisticasScreen"));
const GrillaDisp = lazy(() => import("components/Dispositivo/GrillaDisp"));
const GrillaGrupo = lazy(() => import("components/Grupo/GrillaGrupo"));
const GrillaSubGrupo = lazy(() => import("components/SubGrupo/GrillaSubGrupo"));
const GrillaUsuarios = lazy(() => import("components/Usuario/GrillaUsuarios"));
const GrillaVariables = lazy(() => import("components/Variable/GrillaVariable"));
const GrillaVariableWidget = lazy(() => import("components/AdminDashboard/GrillaVariableWidget"))
const HandleBoard = lazy(() => import("components/Gateways/HandleBoard"));
const Historico = lazy(() => import('components/PantallaHistorico/HistoricoScreen'))
const ListUserPublic = lazy(() => import("pages/ListUserPublic"));

const PageAddApp = lazy(() => import("pages/Aplicacion/PageAddAplicacion"));
const PageListApp = lazy(() => import("pages/Aplicacion/PageListAplicacion"));

const PageListEstadisticaResumen = lazy(() => import("pages/EstadisticaResumen/PageListEstadisticaResumen"));

const PageAddCommand = lazy(() => import("pages/Command/PageAddCommand"));
const PageListCommand = lazy(() => import("pages/Command/PageListCommand"));

const PageAddGateway = lazy(() => import("pages/Gateway/PageAddGatewayNew"));
const PageEditGateway = lazy(() => import("pages/Gateway/PageEditGatewayNew"));
const PageListGateway = lazy(() => import("pages/Gateway/PageListGatewayNew"));

const LocalidadesScreen = lazy(() => import('components/Superadmin/Sandbox/SandboxScreen'))
const LogsAlertasScreen = lazy(() => import("components/LogsDescargos/LogsDescargosScreen"));
const LogsGateways = lazy(() => import("components/LogsGateways/LogGatewayProvider"));
const LogsProvider = lazy(() => import("components/NodosInactividad/LogsProvider"));
const ModelosScreen = lazy(() => import('components/Modelo/ModelosScreen'))
const Nodos = lazy(() => import("components/Nodos/Nodos"));
const NoMatch = lazy(() => import("components/NoMatch"))
const NuevaVariableScreen = lazy(() => import("components/Variable/NuevaVariable/NuevaVariableScreen"));
const NuevoUsuarioPublic = lazy(() => import("components/Usuario/NuevoUsuarioPublic"));
const PageError = lazy(() => import("./PageError"));
const PantallaEmail = lazy(() => import("components/login/PantallaEmail"))
const PantallaMarcas = lazy(() => import("components/Marcas/PantallaMarcas"))
const PantallaPolicial = lazy(() => import("components/PantallaPolicial/PantallaPolicial"))
const Perfil = lazy(() => import("components/Usuario/Perfil"));
const RecuperoContrasena = lazy(() => import("components/login/RecuperoContrasena"))
const RegistrarDispositivo = lazy(() => import("components/Dispositivo/NuevoDispositivo/CrearDispositivo"));
const ScreenAceptarPoliticasyTerminos = lazy(() => import("components/Legales/AceptarTerminosYCondiciones/ScreenAceptarTerminos"));
const ScreenHistoricoPoliticas = lazy(() => import("components/Legales/PoliticasDePrivacidad/Historico/ScreenHistoricoPoliticas"));
const ScreenHistoricoTerminosYCondiciones = lazy(() => import("components/Legales/TerminosYCondiciones/Historico/ScreenHistoricoTerminosYCondiciones"))
const ScreenLegales = lazy(() => import("components/Legales/Legal/ScreenLegales"));
const ScreenLegalesSuperadmin = lazy(() => import("components/Superadmin/Legales/ScreenLegales"));
const ScreenPoliticasDePrivacidad = lazy(() => import("components/Legales/PoliticasDePrivacidad/ScreenPoliticasDePrivacidad"));
const ScreenTerminosYCondiciones = lazy(() => import("components/Legales/TerminosYCondiciones/ScreenTerminosYCondiciones"));
const ServiceProfileScreen = lazy(() => import("components/Superadmin/ServiceProfile/ServiceProfileItem/ServiceProfileScreen"));
const ServiceProfilesScreen = lazy(() => import("components/Superadmin/ServiceProfile/ServiceProfilesScreen"));
const SignIn = lazy(() => import("components/SignIn"));
const SolicitudesIntgradorScreen = lazy(() => import("components/SolicitudMarca/Integrador/SolicitudesIntgradorScreen"));




const drawerWidth = 210;

const useStyles = makeStyles((theme) => ({
  root: {
    height:"100%",
    maxHeight: "100vh",
    display: "flex",
    position: "relative",
  },
  root2: {
    maxHeight: "100vh",
    display: "flex",
    alignItems: "center",
    position: "relative",
  },
  toolbar: {
    paddingRight: 24, // keep right padding when drawer closed
  },
  toolbarIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    padding: "0 8px",
    ...theme.mixins.toolbar,
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    paddingLeft: "0px !important",
    marginRight: 36,
  },
  menuButtonHidden: {
    display: "none",
  },
  title: {
    flexGrow: 1,

  },
  imgLink: {
    cursor: "pointer",
  },
  drawerPaper: {
    position: "relative",
    whiteSpace: "nowrap",
    width: drawerWidth,
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: "hidden",
    transition: theme.transitions.create("width", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing(7),
    [theme.breakpoints.up("sm")]: {
      width: theme.spacing(9),
    },
  },
  appBarSpacer: theme.mixins.toolbar,
  content: {
    width: "100%",
    flexGrow: 1,
    minHeight: "95vh",
    overflow: "none",
  },
  container: {
    minHeight: "89vh",
    minWidth: "99%",
    height: "89vh",
    //marginTop:theme.spacing(2),
    marginBottom: "0px",
    marginLeft: theme.spacing(0),
    marginRight: theme.spacing(0),
    //paddingTop: "3.6em!important",
    paddingLeft: theme.spacing(1),
    paddingTop: theme.spacing(1.5),
    //paddingBottom: theme.spacing(4),
    paddingRight: theme.spacing(1),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  fixedHeight: {
    height: 240,
  },
}));

function Layout({ location }) {
  const classes = useStyles();
  const history = useHistory();
  
  const authContext = useContext(AuthContext);
  const { autenticado, rol, usuario, cerrarSesion } = authContext;

  const isMobile = useContext(IsMobileContext);
  const { isMobileUse } = isMobile;

  const [open, setOpen] = React.useState(false);

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // estado y funciones para el submenu del appbar
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleMenuAppBar = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const openMenuAppBar = anchorEl ? true : false;

  const handleCloseAppBar = () => {
    setAnchorEl(null);
  };
  

  const redirectLogo = () => { // when click in logo page
    let page = null;
    if (rol === Role.Supervisor) {
      page = "/pantalla-policial";
    } else if (rol === Role.Super) {
      page = "/gateway";
    } else if (rol === Role.AltaUsuario) {
      page = "/activar-usuario";
    } else {
      page = "/dashboard";
    }
    window.location.href = page;
  }

  return (
    <div className={classes.root}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        { /*
        * condiciones que ocultan la navegacion si no se aceptaron los terminos y condiciones
        */}
        {
          autenticado && 
          <AppBar
            position="fixed"
            className={clsx(classes.appBar, open && classes.appBarShift)}
          >
            <Toolbar className={classes.toolbar} style={{ background:'linear-gradient(to right, #004B81, #0F76AF, #004B8180)'}}>
              {
                !isMobileUse() &&
                autenticado && ( rol !== Role.Supervisor && rol !== Role.Operador ) &&
                !((!usuario.terminosYCondicionesAceptados || !usuario.politicasDePrivacidadAceptadas) && rol !== Role.Super) &&
                <IconButton
                  edge="start"
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  className={clsx(
                    classes.menuButton,
                    open && classes.menuButtonHidden
                  )}
                >
                  <MdMenu style={{ color: "#FAFAFA" }} />
                </IconButton>
              }
              {
                isMobileUse() ?
                  <Typography
                    component="h1"
                    variant="h6"
                    color="inherit"
                    noWrap
                    className={classes.title}
                  >
                    <img
                      style={{ marginTop: ".6em", width: "45px" }}
                      src="/logomuncba.png"
                      className={classes.imgLink}
                      onClick={redirectLogo}
                      alt='Logo Municipalidad de Córdoba'
                    />
                  </Typography>
                  :
                  <Typography
                    component="h1"
                    variant="h6"
                    color="inherit"
                    noWrap
                    className={classes.title}
                  >
                    <img style={{ marginTop: ".6em" }}
                      width="100px"
                      src="/logomuncba.png"
                      className={classes.imgLink}
                      onClick={redirectLogo}
                      alt='Logo Municipalidad de Córdoba'
                    />
                  </Typography>
              }

              <div className={classes.root2}>
                {
                  autenticado && (rol === Role.Soporte) &&
                  !((!usuario.terminosYCondiciones || !usuario.politicasDePrivacidad) && rol !== Role.Super) &&
                  (
                    (location.pathname !== "/supervisor") ? (
                      <ListaSoporte />
                    )
                      : null
                  )
                }
              </div>

              <div className={classes.root}>
                {
                  autenticado && ( rol === Role.Admin || rol === Role.Operador || rol === Role.Soporte ) &&
                    !((!usuario.terminosYCondicionesAceptados || !usuario.politicasDePrivacidadAceptadas) && rol !== Role.Super) ? 
                    <Tooltip
                      arrow
                      title={
                        <p style={{ fontSize: "12px", minWidth: 70, textAlign: "center" }}>
                          Notificaciones
                        </p>
                      }
                    >
                      <LogState>
                        <MenuNotificaciones />
                      </LogState>
                    </Tooltip>
                  
                    : null
                }

                <Tooltip
                  arrow
                  title={
                    <p style={{ fontSize: "12px", minWidth: 70, textAlign: "center" }}>
                      Opciones
                    </p>
                  }
                >
                  <IconButton
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={handleMenuAppBar}
                    color="inherit"
                  >
                    <MdAccountCircle
                      style={{ color: "#fafafa", fontSize: "25px" }}
                    />

                    <p style={{ margin: "0px", fontSize: 17, fontWeight: 400, padding: "5px" }}>
                      { usuario?.cliente?.razonSocial }
                    </p>
                  </IconButton>
                </Tooltip>

                {
                  autenticado &&
                  <Menu
                    id="menu-appbar"
                    anchorEl={anchorEl}
                    anchorOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    keepMounted
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                    open={openMenuAppBar}
                    onClose={handleCloseAppBar}
                  >
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                      }}
                    >
                      {Util.formatIdClient(usuario.cliente.id)}
                    </MenuItem>

                    {
                    autenticado &&  rol === Role.Admin  &&
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        history.push("/aplicacion");
                      }}
                    >
                      Aplicaciones
                    </MenuItem>
                    }

                    {
                      (usuario.terminosYCondicionesAceptados !== null && usuario.politicasDePrivacidadAceptadas !== null) &&
                      <MenuItem
                        onClick={() => {
                          setAnchorEl(null);
                          history.push("/perfil");
                        }}
                      >
                        Perfil
                      </MenuItem>
                    }
                    <MenuItem
                      onClick={() => {
                        setAnchorEl(null);
                        history.push("/")
                        cerrarSesion();
                      }}
                    >
                      Cerrar Sesión
                    </MenuItem>
                  </Menu>
                }
              </div>
            </Toolbar>
          </AppBar>
        }
        {/* 
        * condiciones que ocultan la navegacion si no se aceptaron los terminos y condiciones
         */}
        {
          autenticado && !!usuario && (  rol !== Role.Supervisor && rol !== Role.Operador  ) &&
          <Sidebar
            open={open}
            handleDrawerOpen={handleDrawerOpen}
            handleDrawerClose={handleDrawerClose}
          />

        }

        <main className={classes.content}>
          {
            autenticado &&
            <div className={classes.appBarSpacer} />
          }
          <Container
            maxWidth="lg"
            className={classes.container}
          >
            <Suspense
              fallback={
                <LoaderSuspense />
              }
            >
              <Switch>
                {/* <RutaPrivada exact path="/dashboard" component={Panel} roles={[Role.Admin, Role.Soporte, Role.Operador]} /> */}
                <Route
                  exact
                  path="/"
                  component={NoMatch}
                />
                <Route
                  exact
                  path="/login"
                  component={SignIn}
                />
                 <Route
                  exact
                  path="/nuevousuario"
                  component={NuevoUsuarioPublic}
                />
               
                <Route
                  exact
                  path="/legal"
                  component={ScreenLegales}
                />
                <Route
                  exact
                  path="/legal/privacy-policy"
                  component={ScreenPoliticasDePrivacidad}
                />
                <Route
                  exact
                  path="/legal/privacy-policy/revisions"
                  component={ScreenHistoricoPoliticas}
                />
                <Route
                  exact
                  path="/legal/terms-of-service"
                  component={ScreenTerminosYCondiciones}
                />
                <Route
                  exact
                  path="/legal/terms-of-service/revisions"
                  component={ScreenHistoricoTerminosYCondiciones}
                />
                <Route
                  exact
                  path="/recupero-contrasena"
                  component={RecuperoContrasena}
                />
                <Route
                  path="/reestablecer/:id"
                  component={PantallaEmail}
                />

                {/*MAGIC_RutaPrivada_CODE*/}

                <RutaPrivada
                  exact
                  path="/perfil"
                  component={Perfil}
                />
                <RutaPrivada
                  exact
                  path="/aplicacion"
                  component={PageListApp}
                  roles={[Role.Admin]}

                />
                <RutaPrivada
                  exact
                  path="/estadisticasresumen"
                  component={PageListEstadisticaResumen}
                  roles={[Role.AltaUsuario, Role.Super]}
                />

                <RutaPrivada
                  exact
                  path="/agregaraplicacion"
                  component={PageAddApp}
                />

                <RutaPrivada
                  exact
                  path="/aplicacion/:id/comandos"
                  component={PageListCommand}
                />             
                
                <RutaPrivada
                  exact
                  path="/aplicacion/:id/agregarcomando"
                  component={PageAddCommand}
                />                         

                <RutaPrivada
                  exact
                  path="/pantalla-policial"
                  component={PantallaPolicial}
                  roles={[Role.Supervisor]}
                />
                <RutaPrivada
                  exact
                  path="/dashboard"
                  component={DashboardScreen}
                  roles={[Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  exacts
                  path="/clientes"
                  component={Cliente}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/gateway"
                  component={HandleBoard}
                  roles={[Role.Super, Role.AltaUsuario, Role.Admin]}
                />
                <RutaPrivada
                  exact
                  path="/gateway-list"
                  component={PageListGateway}
                  roles={[Role.Super, Role.Admin]}
                />
                <RutaPrivada
                  exact
                  path="/gateway-agregar"
                  component={PageAddGateway}
                  roles={[Role.Super, Role.Admin]}
                />                
                <RutaPrivada
                  exact
                  path="/gateway-editar/:id"
                  component={PageEditGateway}
                  roles={[Role.Super, Role.Admin]}
                />                

                <RutaPrivada
                  exact
                  path="/logs-gateways"
                  component={LogsGateways}
                  roles={[Role.Super, Role.AltaUsuario, Role.Admin]}
                />
                <RutaPrivada
                  exact
                  path="/nodos"
                  component={Nodos}
                  roles={[Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/dispositivos"
                  component={GrillaDisp}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/alertas"
                  component={AlertasProvider}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/variables/:disp"
                  component={GrillaVariables}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/registrar-dispositivo"
                  component={RegistrarDispositivo}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/editar-dispositivo/:id"
                  component={EditarDispositivo}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/grupos"
                  component={GrillaGrupo}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/usuarios"
                  component={GrillaUsuarios}
                  roles={[Role.Admin, Role.Soporte, Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/subgrupos/:grupo"
                  component={GrillaSubGrupo}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/widgets"
                  component={GrillaVariableWidget}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/admindashboard/:origen?"
                  component={AdminDashboardPage}
                  roles={[Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  exact
                  path="/supervisor"
                  component={PantallaPolicial}
                  roles={[Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  exact
                  path="/panelHistorico/:id"
                  component={Historico}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/marcas"
                  component={PantallaMarcas}
                  roles={[Role.Integrador, Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/localidades"
                  component={LocalidadesScreen}
                  roles={[Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/deviceProfiles"
                  component={DeviceProfilesScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/modelos/:marca"
                  component={ModelosScreen}
                  roles={[Role.Integrador, Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/logs-alertas"
                  component={LogsAlertasScreen}
                  roles={[Role.Supervisor, Role.Admin]}
                />
                <RutaPrivada
                  exact
                  path="/deviceProfile/:id"
                  component={DeviceProfileScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/applications"
                  component={ApplicationsScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/application/:id"
                  component={ApplicationScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/estadisticas"
                  component={EstadisticasScreen}
                  roles={[Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/serviceProfiles"
                  component={ServiceProfilesScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/serviceProfile/:id"
                  component={ServiceProfileScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/test"
                  component={SolicitudesIntgradorScreen}
                  roles={[Role.Super, Role.Integrador]}
                />
                <RutaPrivada
                  exact
                  path="/nuevaVariable/:disp"
                  component={NuevaVariableScreen}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  exact
                  path="/editarVariable/:disp"
                  component={EditarVariableScreen}
                  roles={[Role.Admin, Role.Soporte]}
                />
                <RutaPrivada
                  path="/centro-de-ayuda"
                  component={CentroDeAyudaScreen}
                  roles={[Role.Super, Role.Integrador, Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  path="/legales"
                  component={ScreenAceptarPoliticasyTerminos}
                  roles={[Role.Integrador, Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  path="/legales-superadmin"
                  component={ScreenLegalesSuperadmin}
                  roles={[Role.Super]}
                />
                <RutaPrivada
                  exact
                  path="/nodos-inactividad"
                  component={LogsProvider}
                  roles={[Role.Admin, Role.Soporte, Role.Operador]}
                />
                <RutaPrivada
                  exact
                  path="/activar-usuario"
                  component={ListUserPublic}
                  roles={[Role.Admin, Role.AltaUsuario]}
                />

                <RutaPrivada
                  component={PageError}
                />
              </Switch>
            </Suspense>

          </Container>
        </main>
      </ThemeProvider>
    </div>
  );
}

export default withRouter(Layout);